import { render, staticRenderFns } from "./nonWorking.vue?vue&type=template&id=93a71e4e&"
import script from "./nonWorking.vue?vue&type=script&lang=ts&"
export * from "./nonWorking.vue?vue&type=script&lang=ts&"
import style0 from "./nonWorking.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports